import { Component, Input } from '@angular/core';

@Component({
  selector: 'error-message',
  standalone: false,
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent {
  @Input() message: string = '';
  @Input() isMarkdown: boolean = false;
  @Input() displayIcon: boolean = true;
}
